import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const HoldingDivider = styled(Grid)(({ theme }) => ({
  position: "relative",
  paddingBottom: theme.spacing(2),
}));

export default HoldingDivider;
